import React, { useState, useRef, useEffect } from 'react'
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import AdapterMoment from "@mui/lab/AdapterMoment";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { TextField } from "@mui/material"
import { useFormContext } from 'react-hook-form'
import PropTypes from "prop-types";
import moments from 'moment'
const { moment } = new AdapterMoment();
const localeMap = {
    en: moment.locale("en"),
    th: moment.locale("th"),
};
const maskMap = {
    en: "dd/mm/yyyy",
    th: "วว/ดด/ปปปป",
};
export default function DateRangeSigleBox({
    minDate, maxDate, name, label, calendarsCount, lableEnd, require,
    disabled, funcOnChange, small, required, funcOnAccept, value, inputSx
}) {
    const {
        register,
        setValue,
        getValues,
        watch,
        formState: { errors },
    } = useFormContext();
    const [locale, setLocale] = React.useState<keyof typeof maskMap>("en");
    const [lstDate, setLstDate] = useState<any>([null, null]);
    const inpRef = useRef(null)

    useEffect(() => {
        setValue(`${name}`, lstDate);
    }, [lstDate])
    useEffect(() => {
        setLstDate(getValues(name) || [null, null])
    }, [])
    return (
        <>
            <LocalizationProvider
                dateAdapter={AdapterMoment}
                locale={localeMap[locale]}
            >
                <MobileDateRangePicker
                    label={label}
                    startText={<>{label} {require ? <span style={{ color: "red" }}>{" *"}</span> : null} </>}
                    disabled={disabled}
                    {...register(name)}
                    InputProps={{
                        readOnly: true,
                        onKeyDown: (e) => e.preventDefault(),
                        onChange: (e) => e.preventDefault()
                    }}
                    value={lstDate}
                    onChange={(newValue, key) => {
                        funcOnChange && funcOnChange(newValue)
                    }}
                    onAccept={(newValue) => {
                        setLstDate(newValue)
                        funcOnAccept && funcOnAccept(newValue)
                    }}
                    showToolbar={false}
                    disableCloseOnSelect={false}
                    clearable
                    inputFormat="DD/MM/YYYY"
                    minDate={minDate || null}
                    maxDate={maxDate || null}
                    calendars={calendarsCount}
                    inputRef={inpRef}
                    DialogProps={{
                        PaperProps: {
                            sx:
                                { ".PrivateDateRangePickerToolbar-penIcon": { display: "none" } }
                        }
                    }}
                    renderInput={({ inputProps, ...startProps }, endProps) => {
                        const startValue = inputProps.value;
                        delete inputProps.value
                        const endValue = endProps.inputProps.value;
                        return (
                            <TextField
                                onKeyDown={(e) => e.preventDefault()}
                                size={small ? "small" : "medium"}
                                sx={{
                                    ...inputSx,
                                    "label.MuiInputLabel-shrink": {
                                        top: "0!important",
                                    }, width: "100%",
                                    " > label": {
                                        top: !small ? "-10px" : "0",
                                        "::after": {
                                            content: required ? '" * "' : '""',
                                            color: "red",
                                            fontWeight: 500
                                        },
                                    },
                                    color: errors && errors[name] ? "red!important" : ""
                                }}
                                {...startProps}
                                inputProps={inputProps}
                                value={startValue && endValue && lstDate[0] && lstDate[1] ? `${startValue}-${endValue}` : ""}
                                error={errors && errors[name]}
                            />
                        )
                    }}
                />
                {errors && errors[name] && <span style={{ color: "red", fontSize: 12 }}>{errors[name][0].message}</span>}
            </LocalizationProvider>
        </>
    )
}

DateRangeSigleBox.defaultProps = {
    label: "",
    lableEnd: "",
    small: true,
    required: false,
    calendarsCount: 1
};

DateRangeSigleBox.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.array.isRequired,
    minDate: PropTypes.instanceOf(moments.prototype),
    maxDate: PropTypes.instanceOf(moments.prototype),
    label: PropTypes.string,
    require: PropTypes.bool,
    calendarsCount: PropTypes.number,
    disabled: PropTypes.bool,
    lableEnd: PropTypes.string,
    required: PropTypes.bool,
    small: PropTypes.bool,
    funcOnChange: PropTypes.func,
    funcOnAccept: PropTypes.func,
    inputSx: PropTypes.any,
};